// extracted by mini-css-extract-plugin
module.exports = {"inquiryCountdown":"inquiryCountdown___1HAkd","red":"red___2si8B"};